import React from "react";
import LeagueContainerResults from "../containers/LeagueContainerResults";

function MatchResultsScores() {
  return <LeagueContainerResults></LeagueContainerResults>;
}

export default MatchResultsScores;
